import { Component, OnInit, AfterViewInit, OnChanges, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Council } from '../../models/SiteGroups';
import { ListService } from '../../services/list.service';
import { concat, orderBy, sortBy, uniqBy } from 'lodash';
import { SitesService } from '../../services/sites.service';
import { forkJoin, switchMap, Subscription, combineLatest } from 'rxjs';
import { BeachSite } from '../../models/BeachSite';
import { BeachwatchPartnersService } from 'src/app/services/beachwatch-partners.service';
import { PartnerGroupModel } from 'src/app/models/BeachwatchPartners/PartnerGroupModel';
import { environment } from 'src/environments/environment';
import { ABOUT_BEACHWATCH_PROTOCOL_URL_EXTERNAL } from 'src/app/models/external-urls';


@Component({
	selector: 'app-beachwatch-partners',
	templateUrl: './our-partners.component.html',
	styleUrls: ['./our-partners.component.scss'],
	providers : [ListService, SitesService]
})

export class OurPartnersComponent implements OnInit, OnDestroy {

	@ViewChild('filterCouncils') filterCouncils : ElementRef;
	public allCouncils : Council[] = [];
	public allPartners : PartnerGroupModel[] = [];
	public allBeachSites : BeachSite[] = [];
	filterText : string;

	public partnerLoginUrl : string = environment.partnerLoginUrl;

	private apiSubscription : Subscription;

	public ABOUT_BEACHWATCH_PROTOCOL_URL = ABOUT_BEACHWATCH_PROTOCOL_URL_EXTERNAL;

	constructor(private listService : ListService,
		private sitesService : SitesService,
		private beachwatchPartnersService : BeachwatchPartnersService)
	{

	}

	ngOnInit(): void {
		const allRequests = [
			this.listService.getCouncilList(),
			this.sitesService.getSitesApi(),
			this.beachwatchPartnersService.getPartnerGroups()
		];
		
		this.apiSubscription = combineLatest(allRequests).subscribe({
			next : (response) => {
				if(Array.isArray(response))
				{
					this.allBeachSites = response[1] ?? [];
					this.allCouncils = orderBy(uniqBy(response[0], 'CouncilId')?.map((council : any) => {
						const sites = response[1].filter((site : any) => {
							return site.Council?.localeCompare(council.CouncilName);
						}).sort((a : BeachSite, b : BeachSite) => {
							return a.SiteName?.localeCompare(b.SiteName);
						});
						
						return { ...council, Sites : sites };
					}), "CouncilName");
					this.allPartners = orderBy(response[2]?.map((partner : PartnerGroupModel) => ({...partner})), "PartnerName");
				}
			},
			error : (ex) => {
				
			},
			complete : () => 
			{

			}
		});
	}

	ngOnDestroy(): void {
		this.apiSubscription.unsubscribe();
	}

	get partners() {
		if(!this.filterText) 
		{
			return this.allPartners;
		}			
		
		return this.allPartners.filter((partner) => {
			const parts = partner.PartnerName.split(' ').filter(Boolean);
			return parts.some((a) => a.toLocaleLowerCase().includes(this.filterText.toLocaleLowerCase()));			
		});
	}

	applyFilter = () => {
		
	}

	get councils() {
		if(!this.filterText) 
		{
			return this.allCouncils;
		}			
		
		return this.allCouncils.filter((council : Council) => {
			const parts = council.CouncilName.split(' ').filter(Boolean);
			return parts.some((a) => a.toLocaleLowerCase().includes(this.filterText.toLocaleLowerCase()));			
		});
	}
	

}
